import { env } from '@/shared/config'

import type { ApiUrl } from './types'

export function authURL(path: string): ApiUrl {
  const host = env.AUTH_URL as string
  return new URL(`${host}/${path}`)
}

export function appURL(path: string): ApiUrl {
  const host = env.APP_URL as string
  return new URL(`${host}/${path}`)
}

export function threadURL(path: string): ApiUrl {
  const host = env.THREAD_URL as string
  return new URL(`${host}/${path}`)
}

export function uploadURL(path: string): ApiUrl {
  const host = ''
  return new URL(`${host}/${path}`)
}
